import { IGlobalStore } from 'src/types/store'
import {
  TStateCommunications,
  createStateSagaCommunications,
} from 'src/helpers/redux'
import { actions as sagaActions, PREFIX } from './actions'
// import * as agentsTypes from 'src/services/agents/types'

export interface IWindow {
  x: number
  y: number
  height: number
  width: number
  open: boolean
  rightSideBar: boolean
  rightSideBarHover: boolean
}

export interface IChatMessage {
  id: string
  role: 'user' | 'assistant'
  content: string
  createdAt: string
  streamingText?: string
}

export interface IAssistantContext {
  source: 'object-page'
  label: string
  prompt: string
  suggestions?: Array<{
    label: string
    prompt: string
  }>
}

export interface IChatThread {
  id: string
  resourceId: string
  title: string
  metadata: {
    startedAt: string
  }
  createdAt: string
  updatedAt: string
  messages: IChatMessage[]
}
export interface IStateData {
  threads: IChatThread[]
  streamMessages: {
    [threadId: string]: undefined
  }
  context?: IAssistantContext
  window: IWindow
}

export interface IState {
  data: IStateData
  communication: TStateCommunications<typeof sagaActions>
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const getStorageState = (key: string) => {
  try {
    return JSON.parse(localStorage.getItem(key) || '{}')
  } catch (error) {
    return {}
  }
}
export const getInitialData = (): IStateData => {
  const stateData = getStorageState(PREFIX)

  const state: IStateData = {
    threads: [],
    window: {
      rightSideBarHover: false,
      rightSideBar: false,
      x: window.innerWidth - 405,
      y: window.innerHeight - 555,
      open: false,
      width: 400,
      height: 550,
      ...stateData.window,
    },
    // ...stateData,

    // threads: {
    //   total: 0,
    //   page: 0,
    //   perPage: 0,
    //   hasMore: false,
    //   threads: [],
    //   // ...stateData?.threads,
    // },
    streamMessages: {},
    context: undefined,
  }

  return state
}

export const initialState: IState = {
  data: getInitialData(),
  communication: createStateSagaCommunications(sagaActions),
}

export type TGlobalStateWithService = IGlobalStore & {
  [PREFIX]: IState
}

export { PREFIX }
